export default "__VITE_ASSET__SeyLooo___"